import { useDepressionContext } from '../../../core/context/DepressionContext';
import Header from '../../../components/Header/Header';
import CompleteExperience from '../../../components/CompleteExperience/CompleteExperience';
import Banner from '../../../components/Banner/Banner';
import ArticleList from '../../../components/ArticleList/ArticleList';
import VideoSlider from '../../../components/VideoSlider/VideoSlider';
import SharedApps from '../../../components/SharedApps/SharedApps';
import {
  StyledPageContainer,
  StyledPageContent,
  StyledPageMainContent,
  StyledPageMainSidebar,
} from '../../../styles/config/pageStyle';

function Depression() {
  const { banner, experienceFirst, experienceSecond, article, videos, sharedApp } =
    useDepressionContext();

  return (
    <>
      <Header title="explore" />
      <Banner data={banner} />

      <StyledPageContainer>
        <StyledPageContent>
          <StyledPageMainContent>
            <CompleteExperience data={experienceFirst} />
            <CompleteExperience data={experienceSecond} />
            <SharedApps data={sharedApp} />
          </StyledPageMainContent>
        </StyledPageContent>
      </StyledPageContainer>

      <StyledPageContainer>
        <StyledPageContent reverse>
          <StyledPageMainSidebar>
            <VideoSlider data={videos} />
          </StyledPageMainSidebar>

          <StyledPageMainContent>
            <ArticleList articles={article} />
          </StyledPageMainContent>
        </StyledPageContent>
      </StyledPageContainer>
    </>
  );
}

export default Depression;
